var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricalSafetyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#FEFCE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8097_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 21.6666C13.1755 21.6671 13.0209 21.6229 12.8874 21.5391C12.7538 21.4552 12.6468 21.3352 12.5787 21.193C12.5106 21.0507 12.4843 20.8921 12.5028 20.7355C12.5213 20.5789 12.5839 20.4307 12.6832 20.3083L20.9332 11.8083C20.9951 11.7368 21.0795 11.6886 21.1724 11.6714C21.2653 11.6542 21.3613 11.6691 21.4447 11.7137C21.528 11.7583 21.5937 11.8298 21.631 11.9167C21.6683 12.0035 21.675 12.1005 21.6499 12.1916L20.0499 17.2083C20.0027 17.3345 19.9869 17.4704 20.0037 17.6041C20.0206 17.7378 20.0696 17.8655 20.1467 17.9761C20.2237 18.0867 20.3264 18.177 20.446 18.2392C20.5656 18.3014 20.6984 18.3337 20.8332 18.3333H26.6666C26.8243 18.3327 26.9789 18.3769 27.1124 18.4608C27.246 18.5446 27.3531 18.6646 27.4211 18.8069C27.4892 18.9491 27.5155 19.1078 27.497 19.2644C27.4785 19.421 27.4159 19.5691 27.3166 19.6916L19.0666 28.1916C19.0047 28.263 18.9204 28.3113 18.8274 28.3285C18.7345 28.3457 18.6385 28.3308 18.5551 28.2862C18.4718 28.2416 18.4061 28.17 18.3688 28.0832C18.3315 27.9963 18.3248 27.8994 18.3499 27.8083L19.9499 22.7916C19.9971 22.6653 20.0129 22.5295 19.9961 22.3958C19.9792 22.262 19.9302 22.1344 19.8532 22.0237C19.7761 21.9131 19.6734 21.8228 19.5538 21.7606C19.4343 21.6984 19.3014 21.6662 19.1666 21.6666H13.3332Z",
    stroke: "#D08700",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8097_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalSafetyIcon);
export default __webpack_public_path__ + "static/media/electrical_safety_icon.68caa2a23d3f1ee80ca4ffd53c053f59.svg";
export { ForwardRef as ReactComponent };